module.exports = __webpack_public_path__ + "img/icon.04a5c270.svg";